export default __webpack_public_path__ + "static/media/DrewConner.c4757c2e.png";